/**
 * Created by nijin on 30/6/17.
 */
import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {EventFormService} from '../event-simulation/event-form.service';
import {FormGroup} from '@angular/forms';

@Component({
    selector: 'nuc-loc-as-attributes',
    templateUrl: './location.attribute.component.html',
    styles:[`.locAttributeList{
    padding: 10px 20px;
    max-height: 220px;
    overflow-y: auto;
    }
    .locAttriForm{
    }
  .locAttriForm .form-group {
      margin-bottom: 0px;
  }
  .locAttriForm .form-group  label{
    font-size: 13px;
    color: #868686;
  }
  .locAttriForm h6{
      color: #3f3f3f;
      font-weight: 600;
      font-size: 14px;
      margin: 15px 0px 5px;
      position: relative;
  }
  .locAttriForm h6:before{
      content: '';
      height: 1px;
      position: absolute;
      left: 15px;
      right: 0px;
      background-color: #e8e8e8;
      top: 8px;
  }
  .locAttriForm h6 span{
      background-color: #f8f8f8;
      position: relative;
      z-index: 1;
      padding-right: 10px;
  }
/*.locAttriForm .form-group .form-group {
    border-bottom: 1px solid #eaeaea;
}*/
`]
})
export class LocationAttributes implements OnInit, OnChanges{
  public locationForm: FormGroup = new  FormGroup({});
  @Input() schema: any;
  @Input() eventData: any;
  constructor(private locForm: EventFormService) { }

  ngOnInit() {
    this.buildForm();
  }

  ngOnChanges(){
    this.buildForm();
  }



  buildForm() {
    if (this.schema.location && this.eventData) {
      this.locationForm =
        this.locForm.locationToForm(this.schema.location, this.eventData.location, true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/things/things-details/location-details/location-attributes.ts